import React from "react";
import FlatList from ".";

const CategoryFlatList = ({
  currArticleId,
  categories,
}: {
  currArticleId: string | null;
  categories?: { name: string; product_content: Queries.product_content[] }[];
}) => {
  if (!categories || categories.length === 0) return null;

  // This takes all the content, removes duplicates and finds the top 5 items by sortand 'newness'
  const topContent = [
    ...categories
      .flatMap((c) => c.product_content)
      .reduce((acc: Map<string, Queries.product_content>, content) => {
        if (!content || !content.slug) return acc;

        if (!acc.has(content.slug)) {
          acc.set(content.slug, content);
        }
        return acc;
      }, new Map<string, Queries.product_content>())
      .values(),
  ]
    .sort((n1, n2) => {
      const sortDiff = (n1.sort ?? 100000) - (n2.sort ?? 100000);
      if (sortDiff !== 0 || !n1.modified_on || !n2.modified_on) {
        return sortDiff;
      }

      return new Date(n2.modified_on).valueOf() - new Date(n1.modified_on).valueOf();
    })
    .filter((content) => currArticleId && content.id !== currArticleId)
    .slice(0, 4);

  if (!topContent || topContent.length === 0) {
    return null;
  }

  // const parentCats = categories.map((category) => category.name);

  // now we group them back by category
  // const contentMap = top5Content.reduce((acc: Map<string, Queries.product_content[]>, content) => {
  //   let pCat: string | null;

  //   // does content have a category already defined
  //   pCat = content.category.find((cat) => [...acc.keys()].includes(cat.name))?.name ?? null;

  //   // if not, find first shared cateogry with parent
  //   if (!pCat) pCat = content.category.find((cat) => parentCats.includes(cat.name))?.name ?? null;

  //   // if no shared category (shouldnt happen) return map unchanged
  //   if (!pCat) return acc;

  //   if (!acc.has(pCat)) {
  //     acc.set(pCat, [content]);
  //   } else {
  //     acc.get(pCat)?.push(content); // will this work ?
  //   }
  //   return acc;
  // }, new Map<string, Queries.product_content[]>());

  const items = topContent.map((node) => ({
    id: node.id,
    title: node.title,
    description: node.description,
    image: node.featuredImage?.childImageSharp?.gatsbyImageData,
    slug: node.externalLink ? node.externalLink : `/resources/${node.slug}`,
    itemFileType: node.content_type.slug_base,
    type: node.content_type.slug_base,
    sort: node.sort ?? 100000,
    modifiedDate: node.modified_on,
  }));

  return (
    <div style={{ paddingTop: "1rem" }}>
      <h2>You Might Also Like </h2>
      <FlatList items={items} />
    </div>
  );
  // return (
  //   <div>
  //     <h2>More information. More inspiration. </h2>
  //     {[...contentMap.keys()].map((category) => {
  //       if (!category) return null;

  //       const items = (contentMap.get(category) ?? []).flatMap((node) =>
  //         node?.id && node?.content_type?.slug_base
  //           ? {
  //               id: node.id,
  //               title: node.title,
  //               description: node.description,
  //               image: node.featuredImage?.childImageSharp?.gatsbyImageData,
  //               slug: node.externalLink ? node.externalLink : `/resources/${node.slug}`,
  //               itemFileType: node.content_type.slug_base,
  //               type: node.content_type.slug_base,
  //               sort: node.sort ?? 100000,
  //               modifiedDate: node.modified_on,
  //             }
  //           : [],
  //       );

  //       if (!items || items.length === 0) {
  //         return null;
  //       }

  //       return (
  //         <div key={category}>
  //           <h2 style={{ margin: "1rem 0" }}>More content related to {category}</h2>
  //           <FlatList items={items} />
  //         </div>
  //       );
  //     })}
  //   </div>
  // );
};

export default CategoryFlatList;
